import { Box, Container, Heading, BoxProps } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { ReactNode } from 'react';

const MotionBox = motion(Box);

interface SectionProps extends BoxProps {
  id?: string;
  title?: string;
  subtitle?: string;
  children: ReactNode;
  bg?: string;
}

export const Section = ({
  id,
  title,
  subtitle,
  children,
  bg,
  ...props
}: SectionProps) => {
  return (
    <MotionBox
      as="section"
      id={id}
      py={{ base: 16, md: 24 }}
      bg={bg}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-100px' }}
      transition={{ duration: 0.6 }}
      {...props}
    >
      <Container maxW="container.xl">
        {title && (
          <Heading
            as="h2"
            size="xl"
            mb={subtitle ? 2 : 8}
            textAlign="center"
          >
            {title}
          </Heading>
        )}
        {subtitle && (
          <Heading
            as="h3"
            size="md"
            fontWeight="normal"
            color="gray.500"
            mb={8}
            textAlign="center"
          >
            {subtitle}
          </Heading>
        )}
        {children}
      </Container>
    </MotionBox>
  );
};
